import React from 'react'
import { View } from 'react-native'

import { section } from '@ui-kit/components/layoutComponents/Section/styles'

import type { NativeProps } from './types'

/**
 * @deprecated This component is deprecated and will be removed when usage is 0%.
 * Please use View from react-native with Tailwind styles.
 */
const Section = (props: NativeProps) => (
  <View {...props} className={section({ className: props.className })} />
)

export default Section
